interface TrialProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export default function TrialProgressBar({ currentStep, totalSteps }: TrialProgressBarProps) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex h-1.5 flex-1 overflow-hidden rounded-full">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className="h-3 flex-1"
            style={{ backgroundColor: i < currentStep ? '#005FFF' : '#EFF5FF' }}
          />
        ))}
      </div>
      <span className="shrink-0 text-[8.9px] leading-[170%] md:text-sm">
        {currentStep}/{totalSteps}
      </span>
    </div>
  );
}
